<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage" id="ded">
<p class="dedicationText"><span><em class="italic"><span>To Nate V. N.<br/>
Thank you for never getting tired of my endless quest<br/>
for “just the right word” and for keeping your<br/>
snickering to a minimum when I sing in the shower.<br/>
Nate, you make my heart smile.</span></em></span></p><br/>
<p class="dedicationText"><span><em class="italic"><span>T. A. I.</span></em></span></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781416538318_ded.vue?89d00496